export const depositAbi = [
  // Read-Only Functions
  "function deposit(address _owner, uint256 _amountOrTokenId, uint16 _color)"
];
